import { useSignal } from "@preact/signals-react"
import { useCallback, useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { isOpenInfoModal } from "Pages/ReportsAlerts/Reports/@signals"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"

export default function useReportInfoModal() {
	const isLoading = useSignal(false)
	const infoModalData = useSignal({})
	const { backendUrl } = useReportBackendApiPath()

	const setIsLoading = () => isLoading.value = true

	const onModalData = useCallback(() => {
		isLoading.value = true
		getSubmit(`${backendUrl}/list`, { id: isOpenInfoModal.value })
			.then(res => {
				infoModalData.value = res
				isLoading.value = false
			})
	}, [])

	useEffect(() => {
		if (isLoading.value) onModalData()
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		setIsLoading,
		data: infoModalData.value,
	}
}